export default "__VITE_ASSET__CUlKKv7A__"